/**
 * Actions designed for non-persistent editing of a selected chart, i.e. lightbox explorer on report view
 */

export enum ExplorerActionType {
  ExploreChart = 'ExploreChart',
  ExploreChartOnLoad = '[Explorer] ExploreChartOnLoad',
  CloseExploration = '[Explorer] CloseExploration',

  SetActivelyExploredPagingOffsetAndPageSize = '[Explorer] SetActivelyExploredPagingOffsetAndPageSize',
  UpdateEncoding = '[Explorer] UpdateEncoding',
  UpdateType = '[Explorer] UpdateType',

  ViewChartData = '[Explorer] ViewChartData',

  MinimizeDataPane = '[Explorer] MinimizeDataPane',
  MaximizeDataPane = '[Explorer] MaximizeDataPane',
  MinimizeChartPane = '[Explorer] MinimizeChartPane',
  MaximizeChartPane = '[Explorer] MaximizeChartPane',

  UpdateTableFormats = '[Explorer] UpdateTableFormats',

  TrackExploreInteraction = '[Explorer] TrackExploreInteraction',
}
